const schType = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មត្តេយ្យដាច់ដោយឡែក' }, { value: 2, text: '២.មត្តេយ្យធនធាន' },
  { value: 3, text: '៣.សាលារៀនអប់រំពិសេស' }
]
const schCond = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ក្រោមស្ដង់ដា' }, { value: 2, text: '២.ក្បែរស្ដង់ដា' },
  { value: 3, text: '៣.ស្ដង់ដា' }, { value: 4, text: '៤.មិនមានការកំណត់' }
]
const yesNo6 = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ប្រើបាន' }, { value: 2, text: '២.មិនបាន' }
]
const a1 = ['ឈ្មោះជាអក្សរខ្មែរ', 'ឈ្មោះជាអក្សរឡាតាំង (អក្សរពុម្ព)', 'អត្តលេខមន្ត្រីរាជការ', 'ថ្ងៃ ខែ ឆ្នាំកំណើត', 'ភេទ',
  'កម្រិតវប្បធម៌ខ្ពស់បំផុត', 'បើជានាយកជំនួស', 'សរុបចំនួនឆ្នាំបម្រើការងារអប់រំ', 'ចំនួនឆ្នាំបម្រើការងារជានាយក', 'ចំនួនម៉ោងបង្រៀនក្នុង១សប្ដាហ៍',
  'លេខទូរស័ព្ទរបស់នាយក/នាយិកា', 'សារអេឡិចត្រូនិច']
const a2 = ['ឈ្មោះសាលារៀន (បច្ចុប្បន្ន)', 'ឈ្មោះសាលារៀន (ឆ្នាំមុន)', 'ភូមិ', 'ឃុំ / សង្កាត់', 'ក្រុង / ស្រុក / ខណ្ឌ', 'រាជធានី / ខេត្ត ',
  'ទីតាំងសាលារៀន', 'បែបផែនទទួលថែកុមារ', 'សាលារៀនបណ្ដែតទឹក', 'សាលារៀនទាំងមូលនៅក្នុងវត្ត', 'ចំនួនថ្នាក់រៀននៅក្នុងវត្ត',
  'សាលារៀនមត្តេយ្យស្ថិតនៅក្នុងសាលាបឋមសិក្សា']
const a3 = []
const pattern = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.កន្លះថ្ងៃ' }, { value: 2, text: '២.ពេញ១ថ្ងៃ' },
  { value: 3, text: '៣.ពេញ១ថ្ងៃនិងអាហារថ្ងៃត្រង់' }
]
const preAge = ['3', '4', '5', '5+']
const preMig = ['សរុប']
const preLevel = ['ថ្នាក់កម្រិតទាប', 'ថ្នាក់កម្រិតមធ្យម', 'ថ្នាក់កម្រិតខ្ពស់', 'ថ្នាក់ចម្រុះ', 'សរុប']
const b4 = ['ចំនួនកុមារដើមឆ្នាំសិក្សា', 'ចំនួនកុមារចុងឆ្នាំសិក្សា', 'ចំនួនកុមារអាយុ៥ឆ្នាំដែលឆ្លងកាត់តេស្តស្តង់ដាឆ្នាំសិក្សា',
  'ចំនួនកុមារអាយុ៥ឆ្នាំ បានបញ្ជូនទៅថ្នាក់ទី១ក្នុងឆ្នាំសិក្សាថ្មី', 'ចំនួនកុមារអាយុ៥ ឆ្នាំ មានការអភិវឌ្ឍផ្នែកទាំង៥ បានល្អប្រសើរ']
const c2 = ['ឯកសារបង្រៀន', 'សម្ភារបង្រៀន', 'ល្បែងលេងក្នុងថ្នាក់', 'សម្ភារបង្រៀន និងរៀនមានគ្រប់គ្រាន់', 'កម្មវិធីទស្សនកិច្ចសិក្សាកុមារអាយុ៥ឆ្នាំ', 'ឯកសារសកម្មភាពសិស្សម្នាក់ៗ']
const d2 = ['លេខាធិការ', 'ឆ្នាំសាលារៀន', 'បុគ្គលិកផ្សេងៗ', 'គ្រូទទួលបន្ទុកការងារសុខភាព',
  'បុគ្គលិកបង្រៀនដែលមានវិធីសាស្ត្រដាក់ពិន័យសិស្សតាមបែបវិជ្ជមាន'
]
const e4 = ['ទោងយោល', 'ក្ដាររំអិល', 'ក្ដារប៉ះប៉ើក', 'ផ្សេងៗ', 'សួនកុមារ']

/* Configuration ON-OFF cells */
const lastStudentOnOff = [
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [0, 0, 0, 0, 1, 1, 1, 1],
  [0, 0, 0, 0, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1]
]
const preStudentOnOff = [
  [1, 1, 0, 0, 0, 0, 1, 1],
  [0, 0, 1, 1, 0, 0, 1, 1],
  [0, 0, 0, 0, 1, 1, 1, 1],
  [0, 0, 0, 0, 0, 0, 1, 1]
]
/** Configuration of UI Page Text */
const preUIText = [
  ['១. អត្តសញ្ញាណ <p><br>និងព័ត៌មានសាវតា</p>', '<strong>១.(ក) នាយក/នាយិកាសាលាមត្តេយ្យសិក្សា</strong>',
    '<strong>១.(ខ) សាលាមត្តេយ្យសិក្សា</strong>', '<strong>១.(គ) អ្នកទទួលបន្ទុកគ្រប់គ្រងសាលារៀនមត្តេយ្យសិក្សា</strong>'],
  ['២. សិស្ស', '២.(ក) កុមារមត្តេយ្យសិក្សាតាមអាយុ និងតាមកម្រិតថ្នាក់ឆ្នាំសិក្សា',
    '២. (ខ) សិស្សពិការ សិស្សជួបការលំបាកផ្នែកសុខភាព និងសិស្សជួបការលំបាកតាមកម្រិតថ្នាក់',
    '២. (គ) កុមារតាមអាយុ (ជនជាតិដើមភាគតិច)', '២. (ឃ) កុមារមត្តេយ្យសិក្សា តាមកម្រិតថ្នាក់ ឆ្នាំសិក្សា',
    '២. (ង) ចំនួនកុមាររៀនក្នុងឆ្នាំសិក្សា'],
  ['៣. បន្ទប់ និងសម្ភារសិក្សា<p><br>/សម្ភារឧបទ្ទេស</p>', '៣. (ក) បន្ទប់រៀន និងថ្នាក់រៀន', '៣. (ខ) ល្បែង និងសម្ភារសិក្សា'],
  ['៤. បុគ្គលិកបង្រៀន <p><br>និងបុគ្គលិកមិនបង្រៀន</p>', '៤. (ក) ចំនួនបុគ្គលិកអប់រំតាមប្រភេទក្របខ័ណ្ឌ', '៤. (ខ) ចំនួនបុគ្គលិកក្របខ័ណ្ឌដែលទទួលមុខងារបន្ថែម',
    '៤.(គ) ចំនួនគ្រូបង្រៀន និងគ្រូកិច្ចព្រមព្រៀងការងារ តាមកម្រិតថ្នាក់', '៤. (ឃ) កម្រិតវប្បធម៌របស់បុគ្គលិកក្របខ័ណ្ឌ និងវគ្គបណ្ដុះបណ្ដាលគរុកោសល្យ'],
  ['៥. អគារ និងបរិក្ខារ', '៥. (ក) ផ្ទៃដីសាលារៀន', '៥. (ខ) អំពីសំណង់', '៥. (គ) ស្ថានភាពអគារ បន្ទប់ និងបរិក្ខារ',
    '៥(ឃ) សម្ភារៈល្បែងលេងក្រៅថ្នាក់', '៥(ង).កន្លែងលាងដៃ', '៥. (ច) បង្គន់អនាម័យ (គិតជាបន្ទប់)',
    '៥.(ឆ).ប្រភពទឹកសម្រាប់ប្រើប្រាស់', '៥(ជ).សម្ភារបរិក្ខារ',
    '៥. អគារ និងបរិក្ខារ', '៥.(ក) ស្ថានភាពអគារ បន្ទប់ និងបរិក្ខារ', '៥.(ខ) ចំនួនបរិក្ខារ', '៥.(គ) ផ្ទៃដីសាលារៀន',
    '៥(ឃ).សម្ភារៈល្បែងលេងក្រៅថ្នាក់', '៥(ង).កន្លែងលាងដៃ', '៥.(ច) បង្គន់អនាម័យ (គិតជាបន្ទប់)',
    '៥.(ឆ).ប្រភពទឹកសម្រាប់ប្រើប្រាស់', '៥(ជ).សម្ភារបរិក្ខា', '៥(ឈ).ខ្សែសេវា អុីនធើណេតសម្រាប់សាលារៀន',
    '៥.(ញ) អគារអន្តេវាសិកដ្ឋាន (សម្រាប់បុគ្គលិកអប់រំ និងសិស្ស)', '៥.(ដ) អគារអ៊ីនធឺណិតសហគមន៍ ដែលស្ថិតក្នុងបរិវេនសាលារៀន'
  ],
  ['៦. ការចូលរួមរបស់សហគមន៍', '៦. (ក) គណៈកម្មការគ្រប់គ្រងសាលារៀន', '៦. (ខ) ហិរញ្ញប្បទានក្នុងឆ្នាំ'],
  ['៧. ការចែកចាយថ្នាំព្រូន', '៧. ការចែកចាយថ្នាំព្រូនក្នុងឆ្នាំសិក្សា'],
  ['៨. ស្ថានភាពទឹកស្អាត និង<p><br>អនាម័យតាមសាលារៀន'],
  [
    '៩. ទិន្នន័យស្តីអំពីការបម្រែ<p><br>បម្រួលអាកាសធាតុ',
    '១.ចំនួនសិស្សមានបញ្ហាសុខភាព ដែលពាក់ព័ន្ធព្រឹត្តិការណ៍នៃគ្រោះមហន្តរាយធម្មជាតិ ក្នុងឆ្នាំសិក្សា',
    '២.ប្រអប់សង្រ្គោះបឋមរបស់សាលារៀន',
    '៣.មូលហេតុបិទសាលារៀន និងចំនួនថ្ងៃបិទសាលារៀនដែលមិនបានគ្រោងទុក',
    '៤.ហេដ្ឋារចនាសម្ព័ន្ធសាលារៀនដែលត្រូវខូចខាត ឬបាត់បង់ដោយសារគ្រោះធម្មជាតិ',
    '៥.ការគ្រប់គ្រងគ្រោះមហន្តរាយ និងផែនការកាត់បន្ថយហានិភ័យ',
    '៦.ចំនួនបន្ទប់រៀនដែលមានកង្ហារ ឬម៉ាស៊ីនត្រជាក់',
    '៧.ចំនួនថ្ងៃដែលសាលារៀនជួប្រទះនឹង៖ ការខ្វះអគ្គីសនី ការខ្វះទឹកស្អាត និងបង្គន់ប្រើប្រាស់មិនកើត ដោយសារគ្រោះមហន្តរាយ',
    '៨.ចំនួនសិស្សដែលអវត្តមានក្នុងឆ្នាំសិក្សា ពី២០ថ្ងៃដល់៤០ថ្ងៃ និងលើស៤០ថ្ងៃ (កុំរាប់សិស្សពីរដង)៖',
    '៩.ការរៀនសូត្រជម្រើសផ្សេងទៀត (Alternative Education) ក្នុងពេលដែលសាលារៀនត្រូវបិទ',
    '១០.ចំនួនសម្ភារសិក្សាដែលត្រូវបានខូចខាត ឬត្រូវបានបំផ្លាញ ដោយសារគ្រោះមហន្តរាយ (សៀវភៅគ្រូ និងសៀវភៅសិស្ស)',
    '១១.ការគ្រប់គ្រងកាកសំណល់នៅសាលារៀន',
    '១២.ហិរញ្ញប្បទានរបស់សាលារៀន (សម្រាប់ផលប៉ះពាល់ដោយសារបម្រែបម្រួលអាកាសធាតុ)'
  ]
]
export {
  schType, schCond, pattern,
  a1, a2, a3,
  preMig, preAge, preLevel,
  b4, c2, d2, e4,
  yesNo6,
  lastStudentOnOff, preStudentOnOff,
  preUIText
}
